import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Avatar from "@material-ui/core/Avatar"
import { isEmpty } from "lodash"

const getImage = (image, size = 400) => {
  if (isEmpty(image)) {
    return ""
  }
  return `https://res.cloudinary.com/${
    process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
  }/image/upload/c_thumb,g_face:auto,z_0.7,h_${size},w_${size},fl_lossy,f_auto/v${
    image.version
  }/${image.public_id}.${image.format ? image.format : "jpeg"}`
}

const CircleAvatar = ({
  children,
  classes,
  image,
  type,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) => {
  return (
    <div>
      {type && type === "chip" ? (
        <Avatar
          src={getImage(image)}
          className={classes.chipAvatar}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={onClick}
        >
          {isEmpty(image) ? children : ""}
        </Avatar>
      ) : (
        <Avatar src={getImage(image)}>{isEmpty(image) ? children : ""}</Avatar>
      )}
    </div>
  )
}
export default withStyles(styles, { withTheme: true })(CircleAvatar)
